module.exports = __webpack_public_path__ + "static/media/sort.4957f2e8.svg";